export const ORDERS_LIST_INITING         = 'ORDERS_LIST_INITING'
export const ORDERS_LIST_REQUESTING      = 'ORDERS_LIST_REQUESTING'
export const ORDERS_LIST_SUCCESS         = 'ORDERS_LIST_SUCCESS'
export const ORDERS_LIST_ERROR           = 'ORDERS_LIST_ERROR'   

export const ORDERS_LIST_NV_REQUESTING      = 'ORDERS_LIST_NV_REQUESTING'
export const ORDERS_LIST_NV_SUCCESS         = 'ORDERS_LIST_NV_SUCCESS'
export const ORDERS_LIST_NV_ERROR           = 'ORDERS_LIST_NV_ERROR'   

export const ORDERS_REMOVE_ITEM_REQUESTING      = 'ORDERS_REMOVE_ITEM_REQUESTING'
export const ORDERS_REMOVE_ITEM_SUCCESS         = 'ORDERS_REMOVE_ITEM_SUCCESS'
export const ORDERS_REMOVE_ITEM_ERROR           = 'ORDERS_REMOVE_ITEM_ERROR'   

export const ORDERS_KHACHHANG_REQUESTING         = 'ORDERS_KHACHHANG_REQUESTING'
export const ORDERS_KHACHHANG_SUCCESS            = 'ORDERS_KHACHHANG_SUCCESS'
export const ORDERS_KHACHHANG_ERROR              = 'ORDERS_KHACHHANG_ERROR'   

export const ORDERS_DAILY_REQUESTING         = 'ORDERS_DAILY_REQUESTING'
export const ORDERS_DAILY_SUCCESS            = 'ORDERS_DAILY_SUCCESS'
export const ORDERS_DAILY_ERROR              = 'ORDERS_DAILY_ERROR'  

export const ORDERS_APPROVE_LIST_REQUESTING     = 'ORDERS_APPROVE_LIST_REQUESTING'  
export const ORDERS_APPROVE_SET_LIST            = 'ORDERS_APPROVE_SET_LIST'  
export const ORDERS_SET_APPROVE_MESSAGE         = 'ORDERS_SET_APPROVE_MESSAGE'  
export const ORDERS_SET_APPROVE_ERROR           = 'ORDERS_SET_APPROVE_ERROR'  

export const ORDERS_EXPORT_XLS_INITING         = 'ORDERS_EXPORT_XLS_INITING'
export const ORDERS_EXPORT_XLS_REQUESTING      = 'ORDERS_EXPORT_XLS_REQUESTING'
export const ORDERS_EXPORT_XLS_SUCCESS         = 'ORDERS_EXPORT_XLS_SUCCESS'
export const ORDERS_EXPORT_XLS_ERROR           = 'ORDERS_EXPORT_XLS_ERROR'

export const ORDERS_LIST_API                    = '/api/v1/export/danhSachDonHang'  
export const ORDERS_EXPORT_API                  = '/api/v1/export/orders_export_by_store'  
export const ORDERS_LIST_NV_API                 = '/api/v1/users/get_list_by_quanly'
export const ORDERS_REMOVE_ITEM_API             = '/api/v1/export/remove_item'
export const ORDERS_KHACHHANG_API               = '/api/v1/export/get_customers_for_order'
export const ORDERS_DAILY_API                   = '/api/v1/kho/getKhoCapDaiLyOfUser' 
export const ORDERS_APPROVE_LIST_API            = '/api/v1/export/approve_order'


// WEBPACK FOOTER //
// ./src/views/Orders/constants.js